import axios from '../axios';



/**
 * 专利申请新增
 * 
 * @url /ent_patent_apply/save
 * 
 * 
 */

export function entpatentapplysave(params) {
    return axios.post('/ent_patent_apply/save', params)
}
/**
 * 专利分页获取
 * 
 * @url /ent_patent_apply/index
 * 
 * 
 */

export function entpatentapplyindex(params) {
    return axios.post('/ent_patent_apply/index', params)
}
/**
 * 专利申请详情
 * 
 * @url /ent_patent_apply/detail
 * 
 * 
 */

export function entpatentapplydetail(params) {
    return axios.post('/ent_patent_apply/detail', params)
}
/**
 * 专利申请修改
 * 
 * @url /ent_patent_apply/update
 * 
 * 
 */

export function entpatentapplyupdate(params) {
    return axios.post('/ent_patent_apply/update', params)
}
/**
 * 专利申请取消
 * 
 * @url /ent_patent_apply/delete
 * 
 * 
 */

export function entpatentapplydelete(params) {
    return axios.post('/ent_patent_apply/delete', params)
}

/**
 * 商标申请新增
 * 
 * @url /ent_trademark_apply/save
 * 
 * 
 */
export function enttrademarkapplysave(params) {
    return axios.post('/ent_trademark_apply/save', params)
}
/**
 * 商标分页获取
 * 
 * @url /ent_trademark_apply/index
 * 
 * 
 */

export function enttrademarkapplyindex(params) {
    return axios.post('/ent_trademark_apply/index', params)
}
/**
 * 商标申请详情
 * 
 * @url /ent_trademark_apply/detail
 * 
 * 
 */

export function enttrademarkapplydetail(params) {
    return axios.post('/ent_trademark_apply/detail', params)
}
/**
 * 商标申请修改
 * 
 * @url /ent_trademark_apply/update
 * 
 * 
 */

export function enttrademarkapplyupdate(params) {
    return axios.post('/ent_trademark_apply/update', params)
}
/**
 * 商标申请取消
 * 
 * @url /ent_trademark_apply/delete
 * 
 * 
 */

export function enttrademarkapplydelete(params) {
    return axios.post('/ent_trademark_apply/delete', params)
}

/**
 * 软著申请新增
 * 
 * @url /ent_copyright_apply/save
 * 
 * 
 */
export function entcopyrightapplysave(params) {
    return axios.post('/ent_copyright_apply/save', params)
}
/**
 * 软著分页获取
 * 
 * @url /ent_copyright_apply/index
 * 
 * 
 */

export function entcopyrightapplyindex(params) {
    return axios.post('/ent_copyright_apply/index', params)
}
/**
 * 软著申请详情
 * 
 * @url /ent_copyright_apply/detail
 * 
 * 
 */

export function entcopyrightapplydetail(params) {
    return axios.post('/ent_copyright_apply/detail', params)
}
/**
 * 软著申请修改
 * 
 * @url /ent_copyright_apply/update
 * 
 * 
 */

export function entcopyrightapplyupdate(params) {
    return axios.post('/ent_copyright_apply/update', params)
}
/**
 * 软著申请取消
 * 
 * @url /ent_copyright_apply/delete
 * 
 * 
 */

export function entcopyrightapplydelete(params) {
    return axios.post('/ent_copyright_apply/delete', params)
}

/**
 * 分页获取科技资讯
 * 
 * @url /article/index
 * 
 * 
 */

export function articleindex(params) {
    return axios.post('/article/index', params)
}
/**
 * 分页获取科技资讯详情
 * 
 * @url /article/detail
 * 
 * 
 */

export function articledetail(params) {
    return axios.post('/article/detail', params)
}
/**
 * 分页获取科技资讯分类
 * 
 * @url /article/category
 * 
 * 
 */

export function articlecategory(params) {
    return axios.post('/article/category', params)
}
/**
 * 政策委托申报
 * 
 * @url /ent_policy_apply/save
 * 
 * 
 */

export function entpolicyapplysave(params) {
    return axios.post('/ent_policy_apply/save', params)
}
/**
 * 分页获取政策委托申报
 * 
 * @url /ent_policy_apply/index
 * 
 * 
 */

export function entpolicyapplyindex(params) {
    return axios.post('/ent_policy_apply/index', params)
}
/**
 * 政策委托申报详情
 * 
 * @url /ent_policy_apply/detail
 * 
 * 
 */

export function entpolicyapplydetail(params) {
    return axios.post('/ent_policy_apply/detail', params)
}
/**
 * 取消政策委托申报
 * 
 * @url /ent_policy_apply/delete
 * 
 * 
 */

export function entpolicyapplydelete(params) {
    return axios.post('/ent_policy_apply/delete', params)
}
/**
 * 修改政策委托申报
 * 
 * @url /ent_policy_apply/update
 * 
 * 
 */

export function entpolicyapplyupdate(params) {
    return axios.post('/ent_policy_apply/update', params)
}

/**
 * 分类获取工业设计作品
 * 
 * @url /ent_design_product/index
 * 
 * 
 */

export function entdesignproductindex(params) {
    return axios.post('/ent_design_product/index', params)
}
/**
 * 工业设计作品添加
 * 
 * @url /ent_design_product/save
 * 
 * 
 */

export function entdesignproductsave(params) {
    return axios.post('/ent_design_product/save', params)
}
/**
 * 工业设计作品更新
 * 
 * @url /ent_design_product/update
 * 
 * 
 */

export function entdesignproductupdate(params) {
    return axios.post('/ent_design_product/update', params)
}
/**
 * 工业设计作品分类
 * 
 * @url /ent_design_product/cate
 * 
 * 
 */

export function entdesignproductcate(params) {
    return axios.post('/ent_design_product/cate', params)
}
/**
 * 工业设计作品详情
 * 
 * @url /ent_design_product/detail
 * 
 * 
 */

export function entdesignproductdetail(params) {
    return axios.post('/ent_design_product/detail', params)
}
/**
 * 工业设计作品附件文件删除
 * 
 * @url /ent_design_product/delete_file
 * 
 * 
 */

export function entdesignproductdeletefile(params) {
    return axios.post('/ent_design_product/delete_file', params)
}
/**
 * 工业设计作品文件删除
 * 
 * @url /ent_design_product/delete
 * 
 * 
 */

export function entdesignproductdelete(params) {
    return axios.post('/ent_design_product/delete', params)
}
/**
 * 政策申报模板
 * 
 * @url /policy/template_list
 * 
 * 
 */

export function policytemplatelist(params) {
    return axios.post('/policy/template_list', params)
}
/**
 * 政策申报模板详情
 * 
 * @url /policy/view_template
 * 
 * 
 */

export function policyviewtemplate(params) {
    return axios.post('/policy/view_template', params)
}
/**
 * 分页获取企业合同
 * 
 * @url /ent_contract/index
 * 
 * 
 */

export function entcontractindex(params) {
    return axios.post('/ent_contract/index', params)
}
/**
 * 新增企业合同
 * 
 * @url /ent_contract/save
 * 
 */

export function entcontractsave(params) {
    return axios.post('/ent_contract/save', params)
}
/**
 * 修改企业合同
 * 
 * @url /ent_contract/update
 * 
 */

export function entcontractupdate(params) {
    return axios.post('/ent_contract/update', params)
}

/**
 * 删除企业合同
 * 
 * @url /ent_contract/delete
 * 
 */

export function entcontractdelete(params) {
    return axios.post('/ent_contract/delete', params)
}

/**
 * 企业合同详情
 * 
 * @url /ent_contract/detail
 * 
 */

export function entcontractdetail(params) {
    return axios.post('/ent_contract/detail', params)
}

/**
 *订单合同/管家合同
 * 
 * @url /company/orders
 * 
 */

export function companyorders(params) {
    return axios.post('/company/orders', params)
}

/**
 * 分页获取财务列表
 * 
 * @url /ent_rd_fee/finance
 * 
 * 
 */

export function entrdfeefinance(params) {
    return axios.post('/ent_rd_fee/finance', params)
}
/**
 * 财务审批
 * 
 * @url /ent_rd_fee/check
 * 
 * 
 */

export function entrdfeecheck(params) {
    return axios.post('/ent_rd_fee/check', params)
}

/**
 * 分页获取费用归集
 * 
 * @url /ent_rd_fee/index
 * 
 * 
 */

export function entrdfeeindex(params) {
    return axios.post('/ent_rd_fee/index', params)
}
/**
 * 分页首页研发投入看板数据
 * 
 * @url /index/rd_stat
 * 
 * 
 */

export function indexrdstat(params) {
    return axios.post('/index/rd_stat', params)
}

/**
 * 分页获取自己的项目-项目管理
 * 
 * @url /ent_tech_research_development/index
 * 
 */

export function researchprojects(params) {
    return axios.post('/ent_tech_research_development/index', params)
}
/**
 * 新增费用归集
 * 
 * @url /ent_rd_fee/save
 * 
 */

export function entrdfeesave(params) {
    return axios.post('/ent_rd_fee/save', params)
}
/**
 * 修改费用归集
 * 
 * @url /ent_rd_fee/update
 * 
 */

export function entrdfeeupdate(params) {
    return axios.post('/ent_rd_fee/update', params)
}

/**
 * 删除费用归集
 * 
 * @url /ent_rd_fee/delete
 * 
 */

export function entrdfeedelete(params) {
    return axios.post('/ent_rd_fee/delete', params)
}

/**
 * 费用归集详情
 * 
 * @url /ent_rd_fee/detail
 * 
 */

export function entrdfeedetail(params) {
    return axios.post('/ent_rd_fee/detail', params)
}
/**
 * 获取我参与的项目
 * 
 * @url /ent_tech_research_development/my
 * 
 */

export function enttechresearchdevelopmentmy(params) {
    return axios.post('/ent_tech_research_development/my', params)
}
/**
 * 获取费用类型
 * 
 * @url /ent_rd_fee/cate
 * 
 */

export function entrdfeecate(params) {
    return axios.post('/ent_rd_fee/cate', params)
}


/**
 *研发辅助账
 *
 * @url /ent_assistrecord/index
 *
 */

export function entassistrecordindex(params) {
    return axios.post('/ent_assistrecord/index', params)
}

/**
 * 产业报告
 * 
 * @url /industry_report/index
 * 
 */

export function industryreportindex(params) {
    return axios.post('/industry_report/index', params)
}
/**
 * 产业报告详情
 * 
 * @url /industry_report/detail
 * 
 */

export function industryreportdetail(params) {
    return axios.post('/industry_report/detail', params)
}

/**
 * 工资列表及导出
 * 
 * @url /ent_rd_wage/index
 * 
 */

export function entrdwageindex(params) {
    return axios.post('/ent_rd_wage/index', params)
}
/**
 * 工资记录生成
 * 
 * @url /ent_rd_wage/create
 * 
 */

export function entrdwagecreate(params) {
    return axios.post('/ent_rd_wage/create', params)
}
/**
 * 删除工资条
 * 
 * @url /ent_rd_wage/delete
 * 
 */

export function entrdwagedelete(params) {
    return axios.post('/ent_rd_wage/delete', params)
}

/**
 * 按月份查询工资明细
 * 
 * @url /ent_rd_wage/by_date
 * 
 */

export function entrdwagebydate(params) {
    return axios.post('/ent_rd_wage/by_date', params)
}

/**
 * 按项目查询工资明细
 * 
 * @url /ent_rd_wage/by_project
 * 
 */

export function entrdwagebyproject(params) {
    return axios.post('/ent_rd_wage/by_project', params)
}
